import { render, staticRenderFns } from "./TermAndCon.vue?vue&type=template&id=13f51a48&"
import script from "./TermAndCon.vue?vue&type=script&lang=js&"
export * from "./TermAndCon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports